import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppConfigService } from 'app/app-config/app-config.service';
import { RuntimeConfig } from 'app/app-config/runtime-config';
import { AppModule } from './app/app.module';

// Loaded with fetch because Angular's HttpClient can only be created by DI, after bootstrap
const promise = fetch(window.location.origin + '/' + AppConfigService.jsonFile)
  .then(response => {
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  });
let configs: RuntimeConfig;

promise.then((value: any): void => {
  // Since the protectedResourceMap comes in as an object and not a map, make it a map
  const originalProtectedResourceMap = value.msalConfig.protectedResourceMap as any;
  value.msalConfig.protectedResourceMap = new Map<string, string[]>();
  for (const key in originalProtectedResourceMap) {
    if (Object.prototype.hasOwnProperty.call(originalProtectedResourceMap, key)) {
      const element = originalProtectedResourceMap[key];
      value.msalConfig.protectedResourceMap.set(key, element);
    }
  }

  configs = new RuntimeConfig(
    value.version,
    value.production,
    value.envName,
    value.serviceUrl,
    value.serviceUrlv2,
    value.serviceUrlv3,
    value.logoutUrl,
    value.msalConfig
  );

  AppConfigService.setConfigs(configs);

  if (configs.production) {
    enableProdMode();
  }

  platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));
},
  (error) => {
    console.error('Could not load configs', error);
  }
);
